module.exports = __webpack_public_path__ + "images/emails/bg-envelope-r-3b237aa1.gif";